import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type GetAccountNameQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
}>;

export type GetAccountNameQueryResult = { __typename?: 'Query' } & {
  account?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName'>>;
};

export const GetAccountNameDocument = /*#__PURE__*/ gql`
  query getAccountName($accountId: String!) {
    account(accountId: $accountId) {
      id
      tradingName
    }
  }
`;

/**
 * __useGetAccountNameQuery__
 *
 * To run a query within a React component, call `useGetAccountNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountNameQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountNameQuery(
  baseOptions: Apollo.QueryHookOptions<GetAccountNameQueryResult, GetAccountNameQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<GetAccountNameQueryResult, GetAccountNameQueryVariables>(GetAccountNameDocument, options);
}
export function useGetAccountNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAccountNameQueryResult, GetAccountNameQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<GetAccountNameQueryResult, GetAccountNameQueryVariables>(GetAccountNameDocument, options);
}
export type GetAccountNameQueryHookResult = ReturnType<typeof useGetAccountNameQuery>;
export type GetAccountNameLazyQueryHookResult = ReturnType<typeof useGetAccountNameLazyQuery>;
